<template>
  <div class="CardSimulation">
    <div class="card z-depth-1 hoverable">
      <div class="card-image">
        <img
          v-bind:src="'data:image/png; base64, ' + simulacao.imgSimulation"
          v-bind:alt="simulacao.title"
          class="materialboxed"
        />
      </div>
      <div class="card-content">
        <p class="row title">
          <span class="col s2">
            <i class="material-icons cardDescriptionIcon grey-text">description</i>
          </span>
          <span class="col s10">{{simulacao.title}}</span>
        </p>
        <p class="row small">
          <span class="col s2">
            <i class="material-icons cardDescriptionIcon grey-text">date_range</i>
          </span>
          <span class="col s10">{{simulacao.data}}</span>
        </p>
        <br />
        <div class="row" v-if="section == 'simulacoes'">
          <div class="col s6">
            <button @click="DeleteSimulacao" class="btn btn-flat col white s12">
              <i class="material-icons left">archive</i> Arquiv
            </button>
          </div>
          <div class="col s6">
            <a
              v-bind:href="'data:text/json;charset=utf-8,' + ResumoSimulacao"
              v-bind:download="simulacao.title + '.json' "
            >
              <button class="btn col s12">
                <i class="material-icons left">save_alt</i> Salvar arquivos
              </button>
            </a>
          </div>
        </div>

        <div class="row" v-if="section == 'arquivados'">
          <div class="col s12">
            <button @click="excluirSimulacao" class="btn col s12 red darken-4">
              <i class="material-icons left">delete</i> Deletar
            </button>
          </div>
          
          <div class="col s12 center">
            <br>  
            <a @click='restaurarSimulacao'>Restaurar</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import M from "materialize-css";
export default {
  name: "CardSimulation",
  data() {
    return {
      ResumoSimulacao: encodeURIComponent(JSON.stringify(this.simulacao))
    };
  },
  props: {
    simulacao: Object,
    tokenSimulacao: String,
    section: String
  },
  mounted() {
    M.Materialbox.init(document.querySelectorAll(".materialboxed"));
  },
  methods: {
    DeleteSimulacao: function() {
      this.$emit("DeleteSimulacaoClick", {
        token: this.tokenSimulacao
      });
    },
    restaurarSimulacao:function(){
      this.$emit("RestaurarSimulacaoClick", {
        token: this.tokenSimulacao
      });
    },
    excluirSimulacao:function(){
      this.$emit("ExcluirSimulacaoClick", {
        token: this.tokenSimulacao
      });
    }
  }
};
</script>